import { Skeleton } from "@/components/ui/skeleton";

const HomeSkeleton = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Warning Banner */}
      <div className="h-10 bg-muted" />
      
      {/* Navigation */}
      <div className="h-16 border-b border-border" />
      
      <main>
        {/* Hero Section */}
        <section className="container mx-auto px-4 py-16 text-center">
          <Skeleton className="h-12 w-3/4 mx-auto mb-4" />
          <Skeleton className="h-6 w-2/3 mx-auto mb-8" />
          <div className="flex justify-center gap-4">
            <Skeleton className="h-12 w-40" />
            <Skeleton className="h-12 w-40" />
          </div>
        </section>

        {/* Services Section */}
        <section className="container mx-auto px-4 py-12">
          <Skeleton className="h-8 w-64 mx-auto mb-8" />
          <div className="grid md:grid-cols-2 gap-6">
            {[1, 2].map((card) => (
              <div key={card} className="bg-card rounded-xl border border-border p-6">
                <div className="flex items-start gap-4">
                  <Skeleton className="h-12 w-12 rounded-lg" />
                  <div className="flex-1">
                    <Skeleton className="h-6 w-48 mb-2" />
                    <Skeleton className="h-4 w-full mb-1" />
                    <Skeleton className="h-4 w-3/4 mb-4" />
                    <div className="flex items-center justify-between">
                      <Skeleton className="h-5 w-24" />
                      <Skeleton className="h-10 w-28" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Social Proof Section */}
        <section className="bg-muted/50 py-12">
          <div className="container mx-auto px-4">
            <Skeleton className="h-8 w-72 mx-auto mb-8" />
            <div className="grid md:grid-cols-3 gap-6">
              {[1, 2, 3].map((card) => (
                <div key={card} className="bg-card rounded-xl border border-border p-6 text-center">
                  <Skeleton className="h-10 w-10 mx-auto mb-4 rounded-full" />
                  <Skeleton className="h-5 w-32 mx-auto mb-2" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-4/5 mx-auto" />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Tools Section */}
        <section className="container mx-auto px-4 py-12">
          <Skeleton className="h-8 w-80 mx-auto mb-8" />
          <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-4">
            {[1, 2, 3, 4, 5].map((tool) => (
              <div key={tool} className="bg-card rounded-xl border border-border p-4 text-center">
                <Skeleton className="h-10 w-10 mx-auto mb-3 rounded-lg" />
                <Skeleton className="h-5 w-24 mx-auto mb-2" />
                <Skeleton className="h-4 w-full" />
              </div>
            ))}
          </div>
        </section>

        {/* Comparison Section */}
        <section className="bg-muted/50 py-12">
          <div className="container mx-auto px-4">
            <Skeleton className="h-8 w-96 mx-auto mb-8" />
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              <div className="bg-card rounded-xl border border-border p-6">
                <Skeleton className="h-6 w-40 mb-4" />
                <div className="space-y-3">
                  {[1, 2, 3, 4].map((item) => (
                    <div key={item} className="flex items-center gap-2">
                      <Skeleton className="h-5 w-5 rounded-full" />
                      <Skeleton className="h-4 flex-1" />
                    </div>
                  ))}
                </div>
              </div>
              <div className="bg-card rounded-xl border border-border p-6">
                <Skeleton className="h-6 w-32 mb-4" />
                <div className="space-y-3">
                  {[1, 2, 3, 4].map((item) => (
                    <div key={item} className="flex items-center gap-2">
                      <Skeleton className="h-5 w-5 rounded-full" />
                      <Skeleton className="h-4 flex-1" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* National Coverage Section */}
        <section className="container mx-auto px-4 py-12">
          <Skeleton className="h-8 w-48 mx-auto mb-8" />
          <div className="flex flex-wrap justify-center gap-2">
            {Array.from({ length: 15 }).map((_, i) => (
              <Skeleton key={i} className="h-8 w-24 rounded-full" />
            ))}
          </div>
        </section>

        {/* FAQ Section */}
        <section className="bg-muted/50 py-12">
          <div className="container mx-auto px-4">
            <Skeleton className="h-8 w-56 mx-auto mb-8" />
            <div className="space-y-3 max-w-3xl mx-auto">
              {[1, 2, 3, 4].map((faq) => (
                <div key={faq} className="bg-card rounded-lg border border-border p-4">
                  <div className="flex items-center justify-between">
                    <Skeleton className="h-5 w-3/4" />
                    <Skeleton className="h-5 w-5" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="container mx-auto px-4 py-16 text-center">
          <Skeleton className="h-10 w-2/3 mx-auto mb-4" />
          <Skeleton className="h-5 w-1/2 mx-auto mb-8" />
          <Skeleton className="h-12 w-48 mx-auto" />
        </section>
      </main>

      {/* Footer */}
      <div className="bg-muted py-12">
        <Skeleton className="h-40 max-w-6xl mx-auto" />
      </div>
    </div>
  );
};

export default HomeSkeleton;
